import { AxiosError } from 'axios';

export interface PuedeEliminarResponse {
  canDelete: boolean;
  motivos?: string[];
  message?: string | null;
}

export function getDeleteErrorMessage(error: unknown): string {
  const axiosError = error as AxiosError<{ message?: string; motivos?: string[] }>;
  const data = axiosError?.response?.data;
  if (data?.message) return data.message;
  if (data?.motivos?.length) return data.motivos.join(' ');
  return 'No se puede eliminar el registro.';
}

export async function confirmarEliminacionMaestro(
  puedeEliminar: () => Promise<PuedeEliminarResponse>,
  confirmMessage: string
): Promise<'cancelled' | 'blocked' | 'confirmed'> {
  const check = await puedeEliminar();
  if (!check.canDelete) {
    return 'blocked';
  }
  if (!window.confirm(confirmMessage)) {
    return 'cancelled';
  }
  return 'confirmed';
}
